export enum FatigueAssessmentView {
    MyForm,
    Pending,
    ToAction,
    ToRevisit,
    Overview,
    Completed
}
